import { useEffect, useState } from "react";

import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  serverTimestamp
} from "firebase/firestore";

import { db } from "../../firebase";

import {
  receiveGRN
} from "../../services/inventoryService";

export default function ManualStockEntry() {

  const user      = JSON.parse(localStorage.getItem("user") || "{}");
  const companyId = user.company_id || "";

  const [items, setItems] =
    useState([]);

  const [vendors, setVendors] =
    useState([]);

  const [submitting, setSubmitting] =
    useState(false);

  const [form, setForm] =
    useState({

      item_name: "",

      qty: "",

      unit: "nos",

      vendor_name: "",

      invoice_no: "",

      rate: "",

      purchase_type:
        "Opening Stock"
    });

  useEffect(() => {

    fetchItems();

    fetchVendors();

  }, []);

  const fetchItems =
    async () => {

      try {

        const snap =
          await getDocs(
            query(
              collection(db, "items"),
              where("company_id", "in", [companyId, ""])
            )
          );

        const data =
          snap.docs.map((doc) => ({

            id: doc.id,

            ...doc.data()
          }));

        setItems(data);

      } catch (error) {

        console.error(
          "Items fetch failed:",
          error
        );
      }
    };

  const fetchVendors =
    async () => {

      try {

        const q = query(

          collection(
            db,
            "purchase"
          ),

          where(
            "company_id",
            "==",
            companyId
          ),

          where(
            "vendor_name",
            "!=",
            ""
          )
        );

        const snap =
          await getDocs(q);

        const uniqueVendors = [

          ...new Set(

            snap.docs

              .map(
                (doc) =>
                  doc.data()
                    .vendor_name
              )

              .filter(Boolean)
          )
        ];

        setVendors(
          uniqueVendors
        );

      } catch (error) {

        console.error(
          "Vendor fetch failed:",
          error
        );
      }
    };

  const handleChange =
    (field, value) => {

      setForm((prev) => ({

        ...prev,

        [field]: value
      }));
    };

  const handleSubmit =
    async () => {

      if (submitting) return;

      if (

        !form.item_name ||

        !form.qty ||

        Number(form.qty) <= 0

      ) {

        alert(
          "Enter valid item and quantity"
        );

        return;
      }

      try {

        setSubmitting(true);

        const qty =
          Number(form.qty);

        const rate =
          Number(
            form.rate || 0
          );

        const totalAmount =
          qty * rate;

        // =================================================
// STRICT MASTER ITEM LOOKUP
// =================================================

const normalizedInput =
  String(form.item_name || "")
    .trim()
    .toLowerCase();

const itemData =
  items.find(
    (item) => {

      const masterName =
        String(
          item.item_name || ""
        )
          .trim()
          .toLowerCase();

      return (
        masterName ===
        normalizedInput
      );
    }
  );


// =========================================
// STRICT item_id REQUIRED
// =========================================

if (
  !itemData ||

  !itemData.item_id ||

  !String(
    itemData.item_id
  ).trim()
) {

  throw new Error(
    "Valid master item not found. Create item in Item Master first."
  );
}

// =========================================
// FIRESTORE IMMUTABLE ID ONLY
// =========================================

const strictItemId =
  String(
    itemData.item_id
  ).trim();

        // =================================================
        // CENTRALIZED INVENTORY ENGINE
        // =================================================

        await receiveGRN({

          company_id:
            itemData.company_id || "",

          item_id:
            strictItemId,

          item_code:
            itemData.item_code || "",

          item_name:
            itemData.item_name,

          category:
            itemData.category ||
            "MATERIAL",

          qty:
            Number(qty),

          unit:

            itemData
              ?.conversion
              ?.base_unit ||

            itemData.unit ||

            form.unit ||

            "nos",

          reference_id:
            "",

          reference_type:
            "manual_stock_entry",

          remarks:
            form.purchase_type,
        });

        // =================================================
        // PURCHASE RECORD
        // =================================================

        if (

          form.purchase_type !==
            "Opening Stock" &&

          form.vendor_name

        ) {

          await addDoc(
            collection(
              db,
              "purchase"
            ),
            {

              vendor_name:
                form.vendor_name,

              invoice_no:
                form.invoice_no || "",

              purchase_type:
                form.purchase_type,

              items: [

                {

                  item_id:
                    strictItemId,

                  item_code:
                    itemData.item_code || "",

                  item_name:
                    itemData.item_name,

                  qty:
                    qty,

                  unit:
                    form.unit,

                  rate:
                    rate,

                  total:
                    totalAmount
                }
              ],

              status:
                "completed",

              company_id:
                itemData.company_id || "",

              created_at:
                serverTimestamp(),

              vendor_last_received:
                serverTimestamp()
            }
          );
        }

        // =================================================
        // EXPENSE ENTRY
        // =================================================

        if (rate > 0) {

          await addDoc(
            collection(
              db,
              "expenses"
            ),
            {

              company_id:
                itemData.company_id || "",

              category:
                "Material Purchase",

              vendor_name:
                form.vendor_name || "",

              invoice_no:
                form.invoice_no || "",

              item_id:
                strictItemId,

              item_code:
                itemData.item_code || "",

              item_name:
                itemData.item_name,

              qty:
                qty,

              amount:
                totalAmount,

              created_at:
                serverTimestamp(),

              purchase_type:
                form.purchase_type
            }
          );
        }

        alert(
          "Stock Added Successfully"
        );

        setForm({

          item_name: "",

          qty: "",

          unit: "nos",

          vendor_name: "",

          invoice_no: "",

          rate: "",

          purchase_type:
            "Opening Stock"
        });

      } catch (error) {

        console.error(
          "Manual stock entry failed:",
          error
        );

        alert(
          error.message ||
          "Stock entry failed"
        );

      } finally {

        setSubmitting(false);
      }
    };

  return (

    <div className="min-h-screen bg-slate-100 p-6">

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg border p-8">

        <button
          onClick={() =>
            window.history.back()
          }
          className="mb-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg font-medium"
        >
          ← Back
        </button>

        <h2 className="text-3xl font-bold mb-8 text-gray-800">
          Manual Stock Entry
        </h2>

        <div className="grid grid-cols-2 gap-6">

          <div>

            <label className="block mb-2 font-medium">
              Item Name
            </label>

            <input
              list="items"
              value={
                form.item_name
              }
              onChange={(e) =>
                handleChange(
                  "item_name",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
              placeholder="Enter item"
            />

            <datalist id="items">

              {items.map(
                (item) => (

                  <option
                    key={item.id}
                    value={
                      item.item_name
                    }
                  />
                )
              )}
            </datalist>
          </div>

          <div>

            <label className="block mb-2 font-medium">
              Quantity
            </label>

            <input
              type="number"
              min="1"
              value={
                form.qty
              }
              onChange={(e) =>
                handleChange(
                  "qty",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />
          </div>

          <div>

            <label className="block mb-2 font-medium">
              Unit
            </label>

            <input
              value={
                form.unit
              }
              onChange={(e) =>
                handleChange(
                  "unit",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />
          </div>

          <div>

            <label className="block mb-2 font-medium">
              Vendor
            </label>

            <input
              list="vendors"
              value={
                form.vendor_name
              }
              onChange={(e) =>
                handleChange(
                  "vendor_name",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />

            <datalist id="vendors">

              {vendors.map(
                (vendor, i) => (

                  <option
                    key={i}
                    value={vendor}
                  />
                )
              )}
            </datalist>
          </div>

          <div>

            <label className="block mb-2 font-medium">
              Invoice No
            </label>

            <input
              value={
                form.invoice_no
              }
              onChange={(e) =>
                handleChange(
                  "invoice_no",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />
          </div>

          <div>

            <label className="block mb-2 font-medium">
              Rate
            </label>

            <input
              type="number"
              min="0"
              value={
                form.rate
              }
              onChange={(e) =>
                handleChange(
                  "rate",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />
          </div>

          <div className="col-span-2">

            <label className="block mb-2 font-medium">
              Entry Type
            </label>

            <select
              value={
                form.purchase_type
              }
              onChange={(e) =>
                handleChange(
                  "purchase_type",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            >
              <option>
                Opening Stock
              </option>

              <option>
                Direct Purchase
              </option>

              <option>
                Adjustment
              </option>

              <option>
                Emergency Purchase
              </option>
            </select>
          </div>
        </div>

        <button
          onClick={handleSubmit}
          disabled={submitting}
          className={`w-full mt-8 py-4 rounded-xl text-white font-bold text-lg ${
            submitting
              ? "bg-gray-400"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {

            submitting

              ? "Processing..."

              : "Add Stock & Update Inventory"
          }
        </button>
      </div>
    </div>
  );
}